


import {HarlequinParsedGameData} from "../server/data/HarlequinParsedGameData";
import {TimelineLite, Timeline, TimelineMax} from "gsap";
import {IBetLineWinData} from "@nolimitcity/slot-game/bin/core/server/data/IServerData";
import {HarlequinGameModuleConfig} from "../HarlequinGameModuleConfig";
import {GameMode} from "@nolimitcity/slot-game/bin/core/gamemode/GameMode";
import {BetLineWin} from "@nolimitcity/slot-game/bin/timelinegameround/game/gameround/presentations/BetLineWin";
import {HarlequinBackground} from "../background/HarlequinBackground";
import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {BetLineEvent} from "@nolimitcity/slot-game/bin/core/betline/event/BetLineEvent";
import {GameConfig} from "@nolimitcity/slot-game/bin/core/gameconfig/GameConfig";
import {ISymbolStateConfig, StateReelSymbol} from "@nolimitcity/slot-game/bin/core/reelsymbol/StateReelSymbol";
import {Reels} from "@nolimitcity/slot-game/bin/core/reel/reelarea/Reels";
import {ParsedGameData} from "@nolimitcity/slot-game/bin/core/server/data/ParsedGameData";
import {Harlequin} from "../Harlequin";

export class HarlequinBetlineToggle extends BetLineWin {

    private _betLineWins:IBetLineWinData [] = [];
    private _toggleTimeline:Timeline | null;
    private _winTimeline:Timeline | null;
    private _loop:boolean = false;
    private _aborted:boolean = false;

    constructor(stagger?: number, loop?:boolean) {
        super(stagger);

        //this._loop = loop;
    }

    prepare(data: HarlequinParsedGameData) {
        this._aborted = false;
        //const gameData:HarlequinParsedGameData =  <HarlequinParsedGameData> data;
        //console.log("BL DATA");
        //console.log(data)¨
        //const initData:ParsedInitData = <ParsedInitData> data;
        //debugger;
        this.abort(false, data);

        if(data!.betLineWins && data!.betLineWins.length > 0) {
            //console.log("BET LINE WINS: ");
            this._betLineWins = data.betLineWins;

            /*
                betLineWins: Array(20)
                0:
                amount: 0.35
                betLine: (5) [1, 1, 1, 1, 1]
                betLineIndex: 0
                multipliedAmount: 1.75
                multiplier: 1
                nrOfSymbols: 3
                symbol: "M4"
                winPosition: (5) [true, true, true, false, false]
            */

            this._betLineWins.forEach((bwins) => {
                //console.log("------------- BL INDEX: " + bwins.betLineIndex + " ----------------------");
                this.parseMultiplierValuesToShow(bwins);
                //console.log(this.parseMultiplierValuesToShow(bwins));
            });

            //console.log(this._betLineWins);
        }
    }

    private parseMultiplierValuesToShow(betLineWins:IBetLineWinData): {
        betLineIndex:number,
        numberOfWinSymbols:number,
        multiplierValue:number
    } {
        const returnObj:{
            betLineIndex:number,
            numberOfWinSymbols:number,
            multiplierValue:number
        } = {
            betLineIndex : betLineWins.betLineIndex,
            numberOfWinSymbols : betLineWins.nrOfSymbols,
            multiplierValue : betLineWins.multipliedAmount / betLineWins.amount
        };

        return returnObj;
    }

    abort(isActive: boolean, data:HarlequinParsedGameData): TimelineLite {
        const tl:TimelineLite = new TimelineLite();

        if(isActive) {
            this._aborted = true;
        }

        (<HarlequinBackground> HarlequinGameModuleConfig.background).playBgSpine("basegame");

        if(this._toggleTimeline) {
            this._toggleTimeline.pause();
            this._toggleTimeline.kill();
            this._toggleTimeline = null;
        }

        if(this._aborted && this._winTimeline) {
            this._winTimeline.pause();
            this._winTimeline.kill();
            this._winTimeline = null;
        }

        HarlequinGameModuleConfig.betLinesView.hideAllBetlines();
        HarlequinGameModuleConfig.multiplierBetWinView.hideAllMpAndVal();

        tl.add(() => HarlequinBetlineToggle.hideAllBetLinesOverride());

        for(let reelId:number = 0; reelId < 5; reelId++) {
            for(let symbolId:number = 0; symbolId < 3; symbolId++) {
                tl.add(this.getHarleySymbolAnimation(reelId, symbolId, GameConfig.instance.SYMBOL_STATES.normal), 0);
            }
        }


        return tl;
        //return super.abort(isActive, data);
    }

    getHarleySymbolAnimation(reelId:number, symbolId:number, state:ISymbolStateConfig):TimelineLite {
        const tl:TimelineLite = new TimelineLite();
        const symbol:StateReelSymbol | null = Reels.getSymbol(reelId, symbolId);
        if(symbol) {
            const symbolAnimation:Timeline = symbol.changeState({
                state : state,
                setStack : true,
                fadeInDuration : 0.0
            })!;
            tl.add([
                //() => BetLineWin.sortSymbolDepthToTop(symbol),
                () => HarlequinGameModuleConfig.harlequinWalkerView.playWildWinSpineToNormal("WildInitialWin", reelId, symbolId),
                symbolAnimation
            ]);
        }
        else {
            debugger;
            throw new Error(`Error: BetLineWin: Cannot find symbol at reel ${reelId} symbol ${symbolId}`);
        }
        return tl;
    }

    private static hideAllBetLinesOverride():void {
        HarlequinGameModuleConfig.betLinesView.individualWinView.individualLineAmountReset()
        EventHandler.dispatchEvent(new GameEvent(BetLineEvent.HIDE_ALL_BET_LINES));
    }

    /*public abort(isActive:boolean, data:ParsedServerData):TimelineLite {
        const tl:TimelineLite = new TimelineLite();

        tl.add(()=> BetLineWin.hideAllBetLines());
        for(let reelId:number = 0; reelId < 5; reelId++) {
            for(let symbolId:number = 0; symbolId < 3; symbolId++) {
                tl.add(this.getSymbolAnimation(reelId, symbolId, GameConfig.instance.SYMBOL_STATES.normal), 0);
            }
        }

        return tl;
    }*/

    getAnimation(data:HarlequinParsedGameData): Timeline | null {
        const tl:Timeline | null =  new TimelineLite();

        if(data.betLineWins && data.betLineWins.length > 0 && tl && !this._aborted) {
            return this._toggleTimeline = this.getHarleyWinAnimations(data);
        }
        return null;
    }

    protected getHarleyWinAnimations(data:HarlequinParsedGameData):Timeline {
        const tl:TimelineMax = new TimelineMax((data && data.nextMode === GameMode.NORMAL)? {repeat: -1} : {});

        if(!this._aborted) {
            tl.add([
                () => (<HarlequinBackground> HarlequinGameModuleConfig.background).playBgSpine("winTogel")
            ]);
            tl.add(() => {}, 0.5);
            for (let i: number = 0; i < data.betLineWins.length; i++) {
                tl.add([
                    HarlequinGameModuleConfig.betLinesView.showBetline((<IBetLineWinData>data.betLineWins[i]).betLineIndex),
                    () => {
                        if (Harlequin.api.gameClientConfiguration.displayIndividualWinsInGame) {
                            HarlequinGameModuleConfig.betLinesView.individualWinView.displayIndividualBetLineAmount(<IBetLineWinData>data.betLineWins[i]);
                        }
                    },
                    //HarlequinGameModuleConfig.multiplierBetWinView.showMpAndVal(data.betLineWins[i].betLine[2], data.betLineWins[i].amount, data.betLineWins[i].multiplier)
                    //,
                    //this.getLineAnimation(<IBetLineWinData>data.betWins[i])
                ], "+=0.1");
                tl.add([
                    () => {
                        HarlequinGameModuleConfig.betLinesView.individualWinView.individualLineAmountReset()
                    },
                    HarlequinGameModuleConfig.betLinesView.hideBetline((<IBetLineWinData>data.betLineWins[i]).betLineIndex),
                    //HarlequinGameModuleConfig.multiplierBetWinView.hideMpAndVal(data.betLineWins[i].betLine[2])
                ], "+=0.6");
            }
        }

        this._winTimeline = tl;
        return tl;
    }
}